import { createStyles } from 'antd-style'

export const useRegisterStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: 520,
    marginBlock: token.marginXXL,
    marginInline: 'auto'
  },
  content: {
    padding: token.paddingXL
  },
  form: {
    width: 320
  },
  result: {
    width: 640
  }
}))
